import { render, staticRenderFns } from "./TextValidateLengthViewer.vue?vue&type=template&id=5bf91f0b&scoped=true&"
import script from "./TextValidateLengthViewer.vue?vue&type=script&lang=ts&"
export * from "./TextValidateLengthViewer.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5bf91f0b",
  null
  
)

export default component.exports